<template>
	<div>
		<div class="position-relative">
			<div class="row">
				<div class="col-1 col-md-4"></div>
				<div class="col-10 col-md-4">
					<div class="text-center">
						<img
							src="/img/logo_with_caption.png"
							width="100%"
						/>
					</div>
					<div class="col-1 col-md-4"></div>
				</div>
			</div>
			<div class="container">
				<div class="row">
					<div class="col-md-6 col-12 card-bphtb">
						<component
							:is="'a'"
							class="text-white card-pajak"
						>
							<!-- <card class="border-0 d-flex card-bphtb" hover shadow
                  body-classes="text-center align-items-center d-flex justify-content-center"> -->
							<!-- <object type="image"> -->
							<img
								class="img-button"
								src="/img/PNG_foto_walikota_wakil_2019.png"
							/>
							<!-- </object> -->
							<!-- </card> -->
						</component>
					</div>
					<div class="col-md-6 col-12">
						<div class="row">
							<div class="col-md-12">
								<card
									class="border-0 d-flex"
									hover
									shadow
								>
									<h5
										class="text-black"
										style="margin-top: 7px"
									>
										Selamat Datang di Portal E-BPHTB Kota Tarakan.
									</h5>
									<h5
										class="text-black"
										style="margin-top: 7px"
									>
										Silahkan registrasi akun Anda untuk memulai pendaftaran
										BPHTB Online dan/atau Login jika sudah meiliki akun:
									</h5>
								</card>
							</div>
							<div class="col-md-6 col-12">
								<component
									:is="'a'"
									@click="goRegistration()"
								>
									<card
										class="border-0 d-flex card-registration"
										hover
										shadow
										body-classes="text-center align-items-center d-flex justify-content-center"
									>
										<object
											type="image"
											class="text-white card-pajak"
										>
											<i
												class="fa fa-address-card-o mr-2"
												style="font-size: 100px"
											></i>
										</object>
										<h6
											class="text-white text-uppercase title-inside-card"
											style="margin-top: 7px; font-size: large"
										>
											{{ registration_label }}
										</h6>
									</card>
								</component>
							</div>
							<div class="col-md-6 col-12">
								<component
									:is="'a'"
									@click="login()"
									v-if="!isLogin"
								>
									<card
										class="border-0 d-flex card-registration"
										hover
										shadow
										body-classes="text-center align-items-center d-flex justify-content-center"
									>
										<object
											type="image"
											class="text-white card-pajak"
										>
											<i
												class="fa fa-sign-in mr-2"
												style="font-size: 100px"
											></i>
										</object>
										<h6
											class="text-white text-uppercase title-inside-card"
											style="margin-top: 7px; font-size: large"
										>
											LOGIN
										</h6>
									</card>
								</component>
								<component
									:is="'a'"
									@click="logout()"
									v-else
								>
									<card
										class="border-0 d-flex card-registration"
										hover
										shadow
										body-classes="text-center align-items-center d-flex justify-content-center"
									>
										<object
											type="image"
											class="text-white card-pajak"
										>
											<i
												class="fa fa-sign-out mr-2"
												style="font-size: 100px"
											></i>
										</object>
										<h6
											class="text-white text-uppercase title-inside-card"
											style="margin-top: 7px"
										>
											LOGOUT
										</h6>
									</card>
								</component>
							</div>

							<div
								class="col-md-12"
								@click="panduan()"
								style="margin-top: 7px; font-size: larger; cursor: pointer"
							>
								<card
									class="border-0 d-flex"
									hover
									shadow
								>
									<h5
										class="text-black"
										style="margin: 7px; font-size: larger; text-align: center"
									>
										Pedoman Penggunaan Aplikasi E-BPHTB Klik Disini
									</h5>
								</card>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-lg"></div>
					<div
						class="col-lg-auto float-right"
						style="border-top: 3px solid #8da2ff"
					>
						<a
							target="_blank"
							rel="noopener"
							href="https://www.facebook.com/infopajakdaerahtarakan/"
							style="font-weight: bolder; padding-left: 15px"
						>
							<img
								class="img-button"
								src="/img/icons/fb.png"
								style="height: 35px; padding-right: 4px"
							/>
							Info Pajak Daerah Tarakan
						</a>
						<a
							target="_blank"
							rel="noopener"
							href="https://wa.me/08115255255"
							style="font-weight: bolder; padding-left: 15px"
						>
							<img
								class="img-button"
								src="/img/icons/wa.png"
								style="height: 35px; padding-right: 4px"
							/>0811-5255-255
						</a>
						<a
							target="_blank"
							rel="noopener"
							href="https://www.instagram.com/infopajakdaerah_tarakan/"
							style="font-weight: bolder; padding-left: 15px"
						>
							<img
								class="img-button"
								src="/img/icons/ig.png"
								style="height: 35px; padding-right: 4px"
							/>infopajakdaerah_tarakan
						</a>
						<a
							target="_blank"
							rel="noopener"
							href="mailto:bpkpadpendapatantrk@gmail.com"
							style="font-weight: bolder; padding-left: 15px"
						>
							<img
								class="img-button"
								src="/img/icons/mail.png"
								style="height: 35px; padding-right: 4px"
							/>bpkpadpendapatantrk@gmail.com
						</a>
					</div>
				</div>
			</div>
		</div>
		<registration
			ref="modal-registration"
			title="Registrasi User"
		></registration>
		<login-user ref="modal-login"></login-user>
		<modal-tracking ref="modal-tracking"></modal-tracking>
		<modal-histories ref="modal-histories"></modal-histories>
		<panduan ref="modal-panduan"></panduan>
	</div>
</template>
<script>
	import Registration from "./GlobalPage/Regstration.vue"
	import LoginUser from "@/views/GlobalPage/LoginUser"
	import ModalTracking from "@/views/GlobalPage/Tracking"
	import ModalHistories from "@/views/GlobalPage/Histories"
	import Panduan from "@/views/GlobalPage/Panduan"
	export default {
		name: "home",
		components: {
			Registration,
			LoginUser,
			ModalTracking,
			ModalHistories,
			Panduan,
		},
		computed: {
			isLogin() {
				return this.$store.state.auth.status.loggedIn
			},
			registration_label() {
				return this.$store.state.auth.status.loggedIn
					? "Menu BPHTB"
					: "REGISTRASI"
			},
		},
		methods: {
			goRegistration() {
				if (this.isLogin) {
					this.$router.push("/landing")
				} else {
					this.$refs["modal-registration"].showModal()
				}
			},
			goDaftar() {
				if (this.isLogin) {
					this.$router.push("/bphtb/daftar")
				} else {
					this.login()
				}
			},
			goForm() {
				if (this.isLogin) {
					this.$router.push("/bphtb/from-daftar")
				} else {
					this.login()
				}
			},
			goTracking() {
				if (this.isLogin) {
					this.$refs["modal-tracking"].showModal()
				} else {
					this.login()
				}
			},
			goHistories() {
				this.$refs["modal-histories"].showModal()
			},
			login() {
				this.$refs["modal-login"].showModal()
			},
			async logout() {
				await this.$store.dispatch("auth/logout")

				this.$router.push("/home")
			},
			async landing() {
				this.$router.push("/landing")
			},
			panduan() {
				this.$refs["modal-panduan"].showModal()
			},
		},
	}
</script>

<style lang="scss" scoped>
	@media (min-width: 1200px) {
		.container {
			max-width: 1373px;
		}
	}
</style>
